import { render, staticRenderFns } from "./InformationsClient.vue?vue&type=template&id=da865f26&scoped=true&"
import script from "./InformationsClient.vue?vue&type=script&lang=js&"
export * from "./InformationsClient.vue?vue&type=script&lang=js&"
import style0 from "./InformationsClient.vue?vue&type=style&index=0&id=da865f26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da865f26",
  null
  
)

export default component.exports